import type { EnvironmentId } from "@amoreg/contracts";
import { buildEnvironmentAuthHeaders } from "@amoreg/client-runtime/rpc";
import { ManagedRelay } from "@amoreg/client-runtime/relay";
import * as Effect from "effect/Effect";
import { runtime } from "../lib/runtime";
import { readPreparedConnection } from "./session";
import type { UploadRequest } from "../lib/attachmentUpload";

/** Read the active connection on each chunk so reconnects can refresh its credentials. */
export const attachmentUploadRequest =
  (environmentId: EnvironmentId): UploadRequest =>
  async (path, init) => {
    const prepared = readPreparedConnection(environmentId);
    if (!prepared) throw new Error("Reconnect to upload your attachment.");
    const url = new URL(path, prepared.httpBaseUrl).toString();
    const headers = await runtime.runPromise(
      Effect.gen(function* () {
        const signer = yield* Effect.serviceOption(ManagedRelay.ManagedRelayDpopSigner);
        return yield* buildEnvironmentAuthHeaders(prepared.httpAuthorization, "POST", url, signer);
      }),
    );
    const requestHeaders = new Headers(init.headers);
    for (const [name, value] of Object.entries(headers)) requestHeaders.set(name, value);
    return fetch(url, {
      ...init,
      headers: requestHeaders,
      credentials: prepared.httpAuthorization === null ? "include" : "omit",
    });
  };
